// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AYFY7","comment":"styles_comment__1Ey-C"};